import { EntitiesStore } from './entities-store.abstract';

import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

export interface INewsPhoto {
  src: string;
  alt: any;
  title: string;
}

export interface IAthleteNews {
  title: string;
  url: string;
  photo: INewsPhoto;

}

export interface IAthleteNewsResult {
  results: Array<IAthleteNews>;
  pager: {
    count: number,
    pages: number,
    items_per_page: number,
    current_page: number,
    next_page: number
  }
}




export class AthleteNewsStore extends EntitiesStore<IAthleteNews> {

  public filter_by_category: string;

  /**
   *The athlete id for make the request.
   *
   * @type {string}
   * @memberof AthletePhotosStore
   */
  athlete_id: string;
  constructor(http: HttpClient) {
    super('null', http);
  }

  /**
   *
   * {@inheritdoc}
   * @returns {Observable<any>}
   * @memberof AthletePhotosStore
   */
  getRequest(params: any, request_more: boolean = false): Observable<any> {
    this.loadingRef = true;
    let page = (this.pagination && this.pagination['pages']) ?
      (this.pagination['next_page'] !== 0 ? this.pagination['next_page'] : this.pagination['page']) : 0;
    if (request_more === false) {
      page = 0;
    }
    params = { page: page };
    if (this.filter_by_category) {
      Object.assign(params, { category: this.filter_by_category.toLowerCase() });
    }
    return this.http.get(environment.drupal_api + (environment.news_api.athlete_news_teaser).replace('athlete_id', this.athlete_id), {
      params: params
    })
      .pipe(
        catchError((e) => of([])),
        tap((next: IAthleteNewsResult) => {
          if (request_more === false) {
            this.dataStream.next(next);
            this.data = next.results;
          } else {
            this.data = Array.from(this.data.concat(next.results).reduce((f, s) =>
              f.set((s as IAthleteNews).title, s), new Map()
            ).values());

            this.dataStream.next(this.data);
          }
          this.pagination = {
            count: next.pager.count,
            pages: next.pager.pages,
            items_per_page: next.pager.items_per_page,
            current_page: next.pager.current_page,
            next_page: next.pager.next_page
          } as any;
          this.loadingRef = false;
          this.requestMore = false;
        }));
  }



}
